webpackJsonp([6],{

/***/ 1911:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1956)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1931),
  /* template */
  __webpack_require__(1976),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2de485cd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1931:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__domain_leiloes_services__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_components_popup_viewer_PopupViewer__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_components_popup_viewer_PopupViewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__default_components_popup_viewer_PopupViewer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__domain_leiloes_helpers_tipos_relatorios_preparacao__ = __webpack_require__(258);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    PopupViewer: __WEBPACK_IMPORTED_MODULE_2__default_components_popup_viewer_PopupViewer___default.a,

    ResultadoImportacaoCsvGrv: function ResultadoImportacaoCsvGrv() {
      return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1968));
    },
    ResultadoImportacaoSecundariaLeilao: function ResultadoImportacaoSecundariaLeilao() {
      return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1969));
    }
  },
  nome: 'historico-logs-importacao-preparacao-leilao',
  props: {
    leilaoId: {
      type: Number,
      default: function _default() {
        return 0;
      },
      required: true
    },
    tipoLog: {
      type: String,
      required: true,
      validator: function validator(val) {
        return __WEBPACK_IMPORTED_MODULE_3__domain_leiloes_helpers_tipos_relatorios_preparacao__["FUNCOES_TIPOS_RELATORIO"].hasOwnProperty(val);
      }
    }
  },
  data: function data() {
    return {
      isLoaded: false,
      historicoLogs: [],
      showViewer: false,
      logSelecionado: null,
      TiposRelatorioPreparacaoLeilao: __WEBPACK_IMPORTED_MODULE_3__domain_leiloes_helpers_tipos_relatorios_preparacao__
    };
  },

  filters: {
    formatarData: function formatarData(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('L LTS');
    }
  },
  created: function created() {
    this.load();
  },

  methods: {
    load: function load() {
      var _this = this;

      this.$loaderOverlay.open().message('Obtendos dados, aguarde...');
      var fn = __WEBPACK_IMPORTED_MODULE_3__domain_leiloes_helpers_tipos_relatorios_preparacao__["FUNCOES_TIPOS_RELATORIO"][this.tipoLog].fn;

      __WEBPACK_IMPORTED_MODULE_1__domain_leiloes_services__["a" /* default */][fn](this.leilaoId).then(function (result) {
        _this.historicoLogs = result.data;
        _this.isLoaded = true;
        _this.$loaderOverlay.hide();
      }).catch(function (error) {
        alert('Ocorreu um erro ao obter os dados');
        console.log(error.data);
        _this.$loaderOverlay.hide();
      });
    },
    openViewer: function openViewer() {
      this.showViewer = true;
    },
    closeViewer: function closeViewer() {
      this.showViewer = false;
    },
    selecionaLog: function selecionaLog(log) {
      this.logSelecionado = log;
      this.openViewer();
    }
  }
});

/***/ }),

/***/ 1945:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1903)(true);
// imports


// module
exports.push([module.i, "td[data-v-2de485cd]{text-align:center}.informacoes-historico[data-v-2de485cd]{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;-ms-flex-pack:distribute;justify-content:space-around}.informacoes-historico span[data-v-2de485cd]{font-weight:700}.resultado-success[data-v-2de485cd]{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center;-ms-flex-pack:distribute;justify-content:space-around}", "", {"version":3,"sources":["/opt/buildhome/repo/src/app/website/leiloes/components/HistoricoLogsImportacaoPreparacaoLeilao.vue"],"names":[],"mappings":"AACA,oBACE,iBAAkB,CACnB,AACD,wCACE,oBAAqB,AACrB,aAAc,AACd,uBAAwB,AACpB,mBAAoB,AACxB,sBAAuB,AACnB,mBAAoB,AACxB,yBAA0B,AACtB,4BAA8B,CACnC,AACD,6CACE,eAAkB,CACnB,AACD,oCACE,oBAAqB,AACrB,aAAc,AACd,0BAA2B,AACvB,sBAAuB,AAC3B,sBAAuB,AACnB,mBAAoB,AACxB,yBAA0B,AACtB,4BAA8B,CACnC","file":"HistoricoLogsImportacaoPreparacaoLeilao.vue","sourcesContent":["\ntd[data-v-2de485cd] {\n  text-align: center\n}\n.informacoes-historico[data-v-2de485cd] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n.informacoes-historico span[data-v-2de485cd] {\n  font-weight: bold;\n}\n.resultado-success[data-v-2de485cd] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1956:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1945);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1904)("50a54242", content, true, {});

/***/ }),

/***/ 1976:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.isLoaded) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Histórico de logs de importações")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(!_vm.historicoLogs.length) ? _c('div', {
    staticClass: "text-dark resultado-success m-t-xl"
  }, [_c('i', {
    staticClass: "fa fa-warning fa-5x"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.TiposRelatorioPreparacaoLeilao.FUNCOES_TIPOS_RELATORIO[_vm.tipoLog].messageEmpty))])]) : _c('div', {
    staticClass: "informacoes-historico m-b-lg"
  }, [_c('div', [_vm._v("Foram encontrados "), _c('span', [_vm._v(_vm._s(_vm.historicoLogs.length))]), _vm._v(" log" + _vm._s(_vm.historicoLogs.length !== 1 ? 's' : '') + " para este leilão")])]), _vm._v(" "), (_vm.historicoLogs.length) ? _c('div', [_c('table', {
    staticClass: "table-lotes-leilao table table-clicked table-striped bg-whit b-a"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-nowrap text-center"
  }, [_vm._v("Data da Importação")]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap text-center"
  }, [_vm._v("Opções")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.historicoLogs), function(log) {
    return _c('tr', {
      staticClass: "leilao-list-lote-item"
    }, [_c('td', [_vm._v(_vm._s(_vm._f("formatarData")(log.data.date)))]), _vm._v(" "), _c('td', [_c('u-button', {
      staticClass: "btn btn-info btn-xs",
      on: {
        "click": function($event) {
          return _vm.selecionaLog(log)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    }), _vm._v(" Ver detalhes")])], 1)])
  }), 0)])]) : _vm._e()])])]), _vm._v(" "), (_vm.showViewer) ? _c('popup-viewer', {
    attrs: {
      "title": "Histórico de logs de importação"
    },
    on: {
      "close": _vm.closeViewer
    }
  }, [(_vm.tipoLog === _vm.TiposRelatorioPreparacaoLeilao.TIPO_RELATORIO_CSV_GRV) ? _c('ResultadoImportacaoCsvGrv', {
    attrs: {
      "relatorio": _vm.logSelecionado
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tipoLog === _vm.TiposRelatorioPreparacaoLeilao.TIPO_RELATORIO_IMPORTACAO_SECUNDARIA) ? _c('ResultadoImportacaoSecundariaLeilao', {
    attrs: {
      "relatorio": _vm.logSelecionado
    }
  }) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/6.f19190cc5cb0aed1d4b4.js